export const BuildInfo = {timestamp:1777479536000}
